import React from 'react';
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#fffbf5] border-t border-stone-200 pt-16 pb-8 px-4" data-id="element-16">
      <div className="max-w-7xl mx-auto" data-id="element-17">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-18">
          <div className="col-span-1 md:col-span-2" data-id="element-19">
            <div className="flex items-center gap-2 mb-6" data-id="element-20">
              <div className="w-10 h-10 bg-green-600 rounded-full flex items-center justify-center text-white text-xl" data-id="element-21">
                🥗
              </div>
              <span className="font-poppins font-bold text-2xl text-stone-900 tracking-tight" data-id="element-22">
                BeVeg<span className="text-green-600" data-id="element-23">Today</span>
              </span>
            </div>
            <p className="text-stone-600 max-w-sm mb-6" data-id="element-24">
              Inspiring the world to eat more plants, one delicious recipe at a
              time. Join our community of food lovers!
            </p>
            <div className="flex gap-4" data-id="element-25">
              <a href="#" className="bg-stone-100 p-2 rounded-full text-stone-600 hover:bg-green-100 hover:text-green-600 transition-colors" data-id="element-26">
                <Instagram size={20} data-id="element-27" />
              </a>
              <a href="#" className="bg-stone-100 p-2 rounded-full text-stone-600 hover:bg-blue-100 hover:text-blue-600 transition-colors" data-id="element-28">
                <Twitter size={20} data-id="element-29" />
              </a>
              <a href="#" className="bg-stone-100 p-2 rounded-full text-stone-600 hover:bg-blue-100 hover:text-blue-800 transition-colors" data-id="element-30">
                <Facebook size={20} data-id="element-31" />
              </a>
              <a href="https://www.youtube.com/c/BeVegToday" className="bg-stone-100 p-2 rounded-full text-stone-600 hover:bg-red-100 hover:text-red-600 transition-colors" data-id="element-32">
                <Youtube size={20} data-id="element-33" />
              </a>
            </div>
          </div>

          <div data-id="element-34">
            <h4 className="font-bold text-stone-900 mb-6" data-id="element-35">Quick Links</h4>
            <ul className="space-y-4 text-stone-600" data-id="element-36">
              <li data-id="element-37">
                <a href="#" className="hover:text-green-600 transition-colors" data-id="element-38">
                  Home
                </a>
              </li>
              <li data-id="element-39">
                <a href="#suggester" className="hover:text-green-600 transition-colors" data-id="element-40">
                  Find Recipes
                </a>
              </li>
              <li data-id="element-41">
                <a href="#categories" className="hover:text-green-600 transition-colors" data-id="element-42">
                  Categories
                </a>
              </li>
              <li data-id="element-43">
                <a href="#videos" className="hover:text-green-600 transition-colors" data-id="element-44">
                  Videos
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-45">
            <h4 className="font-bold text-stone-900 mb-6" data-id="element-46">Categories</h4>
            <ul className="space-y-4 text-stone-600" data-id="element-47">
              <li data-id="element-48">
                <a href="#" className="hover:text-green-600 transition-colors" data-id="element-49">
                  Quick & Easy
                </a>
              </li>
              <li data-id="element-50">
                <a href="#" className="hover:text-green-600 transition-colors" data-id="element-51">
                  Healthy Choice
                </a>
              </li>
              <li data-id="element-52">
                <a href="#" className="hover:text-green-600 transition-colors" data-id="element-53">
                  Instant Bites
                </a>
              </li>
              <li data-id="element-54">
                <a href="#" className="hover:text-green-600 transition-colors" data-id="element-55">
                  Indian Cuisine
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 pt-8 text-center text-stone-500 text-sm" data-id="element-56">
          <p data-id="element-57">
            &copy; {new Date().getFullYear()} BeVegToday. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}